module.exports = __webpack_public_path__ + "img/card-10.5a8f0909.png";